/**
 * Management Routes (Administrator Only)
 * 
 * Routes for administrators (user_admin = true) managing system-wide features.
 * These routes are NOT for regular users managing their own events.
 * 
 * Note: Using /management instead of /admin to clearly separate from user routes.
 */

export const ADMIN_ROUTES = {
  /**
   * Superadmin / management login (admin@jubiel.local or user_admin accounts).
   * Both /management/login and /superadmin/login render the same page.
   */
  login: (locale: string) => `/${locale}/management/login`,

  /**
   * Template management (administrator only)
   */
  templates: (locale: string) => `/${locale}/management/templates`,

  /**
   * System management (administrator only)
   * - Soft-deleted accounts
   * - Soft-deleted events
   */
  management: (locale: string) => `/${locale}/management`,

  /**
   * Management page, Users tab pre-filtered by a search term (name or email).
   * Used by the admin events list to jump from an event to its owner (JUB-92).
   */
  managementUsersSearch: (locale: string, search: string) =>
    `/${locale}/management?tab=users&search=${encodeURIComponent(search)}`,

  /**
   * Events listing (administrator only)
   * - All users' events with sorting, filtering, pagination
   */
  events: (locale: string) => `/${locale}/management/events`,

  /**
   * User profile (superadmin only)
   * - User details and all events with stats
   */
  userProfile: (locale: string, userId: string | number) => `/${locale}/management/users/${userId}`,

  /**
   * Campaign management (discounts/vouchers)
   * - List, create, edit campaigns
   */
  campaigns: (locale: string) => `/${locale}/management/campaigns`,

  /**
   * Campaign editor
   * - Edit campaign details, codes, questions
   */
  campaignEditor: (locale: string, uuid: string) => `/${locale}/management/campaigns/${uuid}`,
} as const;

